import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { goBack } from 'react-router-redux';

// Misc
import objectToFormData from '../../../utils/objectToFormData';
import {
  createAvailableTextureRequest,
  getIsLoading,
  updateAvailableTextureRequest,
  getAvailableTextureByIdRequest,
} from '../../../ducks/availableTextures';

// Import Components
import { DesignTemplatesLayout } from '../index';
import DetailEditForm from './DetailEditForm';
import DetailCreateForm from './DetailCreateForm';

ColorsDetail.propTypes = {
  // from connect/react-router-redux
  goBack: PropTypes.func,
  // from connect/availableColorsReducer
  createAvailableTextureRequest: PropTypes.func,
  isLoading: PropTypes.bool,
};

function ColorsDetail({
  goBack,
  getAvailableTextureByIdRequest,
  createAvailableTextureRequest,
  updateAvailableTextureRequest,
  isLoading,
  match: {
    params: { id },
  },
}) {
  const isEdit = id !== 'new';

  const form_submitHandler = function (values) {
    const texture = { texture: { ...values } };
    if (isEdit) {
      updateAvailableTextureRequest(id, objectToFormData(texture));
    } else {
      createAvailableTextureRequest(objectToFormData(texture));
    }
  };

  const buttonGoBack_clickHandler = function () {
    goBack();
  };

  const getItem = function () {
    if (id !== 'new') {
      getAvailableTextureByIdRequest(id);
    }
  };

  return (
    <DesignTemplatesLayout
      isLoading={isLoading}
      pageTitle="textures"
      buttonTitle="Go back"
      getItem={getItem}
      button_clickHandler={buttonGoBack_clickHandler}
    >
      {isEdit ? <DetailEditForm onSubmit={form_submitHandler} /> : <DetailCreateForm onSubmit={form_submitHandler} />}
    </DesignTemplatesLayout>
  );
}

// Enhancer
const mapStateToProps = (state) => ({
  isLoading: getIsLoading(state),
});
const mapDispatchToProps = {
  goBack,
  createAvailableTextureRequest,
  updateAvailableTextureRequest,
  getAvailableTextureByIdRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(ColorsDetail);
